import React from 'react'

class ContactForm extends React.Component {

  /**
   * @class ContactForm
   * @method constructor
   * Initialize the form state and bind events
   */
  constructor(props) {
    super(props)
    this.state = {
      fullName: '',
      email: '',
      message: '',
      errors: {}
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)

    // Refs
    this.form = React.createRef()
    this.labels = {
      'fullName': React.createRef(),
      'email': React.createRef(),
      'message': React.createRef(),
    };
  }

  /**
   * @class ContactForm
   * @method handleChange
   * Update state on input change
   */
  handleChange(event) {
    const target = event.target;
    const name = target.name || '';
    const value = target.value || '';
    if (name) {
      this.setState({
        [name]: value
      })
    }
  }

  /**
   * @class ContactForm
   * @method handleSubmit
   * Validate inputs and post the form on submit
   */
  handleSubmit(event) {
    const that = this
    const state = this.state
    new Promise((resolve, reject) => {
      // Validate form data
      let errors = {};
      const {fullName, email, message} = state
      if (fullName === '') {
        errors.fullName = 'Merci de renseigner votre prénom'
      }
      if (email === '') {
        errors.email = 'Merci de renseigner votre e-mail'
      } else if (!/\S+@\S+\.\S+/.test(email)) {
        errors.email = 'Merci de renseigner un e-mail valide'
      }
      if (message === '') {
        errors.message = 'Merci de renseigner un message'
      }
      // Send form if there are no errors
      if (Object.keys(errors).length === 0) {
        resolve({
          fullName,
          email,
          message
        })
      } else {
        reject(errors);
      }
    })
      .then(requestBody => {
        return fetch(`${process.env.REACT_APP_PUBLIC_API_URL}/cosmic-contact-form/v1/contact`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=UTF-8'
          },
          body: JSON.stringify(requestBody)
        })
      })
      .then(response => {
        return Promise.all([
          response.ok,
          response.json()
        ])
      })
      .then(([ok, data]) => {
        const responseData = data.data || null
        if (!ok) {
          const errors = (responseData && responseData.errors) || null
          throw errors
        }
        return responseData
      })
      .then((data) => {
        const form = that.form.current || null
        if (form) {
          const message = form.querySelector('.contact-form__confirmation__message')
          message.textContent = (data && data.message) || 'Merci !'
          form.classList.add('contact-form--sent')
        }
      })
      .catch((errors) => {
        if (typeof errors === 'undefined' || !errors) {
          return;
        }
        // Update state
        state.errors = errors;
        that.setState(state);
        // Show errors
        for (let inputName in this.labels) {
          if (!this.labels.hasOwnProperty(inputName)) {
            continue;
          }
          // Retrieve label and input
          const label = this.labels[inputName].current || null;
          const input = (label && label.querySelector('[name=' + inputName + ']')) || null;
          const errorMessage = (label && label.querySelector('.form-row__error')) || null;
          if (!(label && input && errorMessage)) {
            continue;
          }
          // Update error display
          const error = errors[inputName] || null;
          if (error) {
            errorMessage.textContent = error
            label.classList.add('form-row--has-error')
          } else {
            label.classList.remove('form-row--has-error')
          }
        }
      })
    event.preventDefault()
  }

  render() {
    return (
      <form className="bg--white contact-form" onSubmit={this.handleSubmit} ref={this.form}>
        <p className="contact-form__title">
          Vous souhaitez nous soumettre un <strong>projet</strong> ? Une <strong>idée</strong> ?
        </p>
        <div className="contact-form__inputs">
          <label className="form-row" ref={this.labels.fullName}>
            <input type="text" name="fullName" placeholder="Votre nom" value={this.state.fullName} onChange={this.handleChange}/>
            <span className="form-row__error"/>
          </label>
          <label className="form-row" ref={this.labels.email}>
            <input type="text" name="email" placeholder="Votre email" value={this.state.email} onChange={this.handleChange} />
            <span className="form-row__error"/>
          </label>
          <label className="form-row form-row--large" ref={this.labels.message}>
            <textarea name="message" placeholder="Votre message" value={this.state.message} onChange={this.handleChange} />
          </label>
        </div>
        <div className="contact-form__actions">
          <input type="submit" value="Envoyer !"/>
        </div>
        <div className="contact-form__confirmation">
          <span className="contact-form__confirmation__message"/>
        </div>
      </form>
    );
  }
}

export default ContactForm



// WEBPACK FOOTER //
// ./src/components/ContactForm.jsx